import { query } from '@/services/down/owner';

export default {
  namespace: 'owner',
  state: {},

  effects: {
    *query({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);
    },
  },
};
